import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { Container, Grid, useMediaQuery } from "@material-ui/core";
import { Tooltip } from "@progress/kendo-react-tooltip";
import {
  InformationADAkubicaFirmaDigitalInvitedPure,
  PromotionalFooterPure,
  GridHLPure,
  DialogSystemGLPure,
  SubtitleCustom,
  ButtonHLPure,
  DialogFormHLPure,
  GridSimpleReadHLPure,
  ValidationCodePure,
  FilterHLPure,
  TooltipHLPure
} from "../../pures";
import {
  ItemMenuBlueImage,
  ItemMenuGreenImage
} from "../../../assets/logos/icons";
import DialogDeleteSignaturePure from "../../pures/dialog-delete-signature/dialog-delete-signature.pure";
import "./signature-receive-panel.css";
import CanvasDraw from "react-canvas-draw";

const SignatureReceivePanelView = (props) => {
  const { newRequests, filterOptions, stateSortStart, stateSortLimit } = props
  const { t } = useTranslation();
  let edit = t("cellDetailSignatureRequest.seeDetail");
  let tooltipTracking = t("cellDetailSignatureRequest.tooltipTracking");
  let tooltipSeeDetail = t("cellDetailSignatureRequest.tooltipSeeDetail");
  let tooltipDelete = t("cellDetailSignatureRequest.tooltipCancelSignRequest");
  let tooltipStampingTime = t(
    "cellDetailSignatureRequest.tooltipServiceStampingTime"
  );
  let tooltipConservationMessage = t(
    "cellDetailSignatureRequest.tooltipServiceConservationMessage"
  );

  const [selectedValueFilter, setSelectedValue] = useState("Pendiente")
  const [requests, setRequests] = useState([])
  const [selectedUser, setSelectedUser] = useState()
  const [selectedItem, setSelectedItem] = useState({})
  const pad = useRef(null)

  let infodevice = navigator.userAgent.toLowerCase()
  let isMobile = infodevice.includes("android");
  isMobile = isMobile || infodevice.includes("iphone");
  isMobile = isMobile || infodevice.includes("ipad");
  isMobile = isMobile || infodevice.includes("mobile");

  const strToboolean = (value) => {
    if (value && typeof value === "string") {
      if (value.toLowerCase() === "true") return true;
      if (value.toLowerCase() === "false") return false;
    }
    return value;
  };

  const filterChange = (e) => {
    const selectedOption = strToboolean(e.target.value);
    setSelectedValue(selectedOption);
  };

  useEffect(() => {
    if (selectedValueFilter != "Todas") {
      if (selectedValueFilter == "Pendientes") {
        setRequests(newRequests.filter(
          (request) => request.solicitudeStatus === "Pendiente"
        ));
      } else if (selectedValueFilter == "Canceladas") {
        setRequests(newRequests.filter(
          (request) => request.solicitudeStatus === "Cancelado"
        ));
      } else if (selectedValueFilter == "Rechazadas") {
        setRequests(newRequests.filter((request) => request.solicitudeStatus === "Rechazado"))
      } else {
        setRequests(newRequests.filter(
          (request) => request.solicitudeStatus === selectedValueFilter
        ));
      }
    } else {
      setRequests(newRequests);
    }
  }, [selectedValueFilter])

  useEffect(() => {
    if (selectedValueFilter != "Todas") {
      if (selectedValueFilter == "Pendientes") {
        setRequests(newRequests.filter((request) => request.solicitudeStatus === "Pendiente"))
      } else if (selectedValueFilter == "Canceladas") {
        setRequests(newRequests.filter((request) => request.solicitudeStatus === "Cancelado"))
      } else if (selectedValueFilter == "Rechazadas") {
        setRequests(newRequests.filter((request) => request.solicitudeStatus === "Rechazado"))
      } else {
        setRequests(newRequests.filter((request) => request.solicitudeStatus === selectedValueFilter))
      }
    } else {
      setRequests(newRequests)
    }
  }, [newRequests])

  const longmatches = useMediaQuery("(max-width:900px)")
  const showFeatures = useMediaQuery("(max-width: 1110px)")
  const showLimitDate = useMediaQuery("(max-width: 940px")
  const showCreatedDate = useMediaQuery("(max-width: 1252px")
  const showStatus = useMediaQuery("(max-width: 1462px")
  const showIconTracking = useMediaQuery("(max-width: 650px")
  const showActions = useMediaQuery("(max-width: 650px)")

  const globalContainerStyles = {
    display: "inline-block",
    justifyContent: "flex-start",
    maxWidth: "100%",
    backgroundColor: "white",
    padding: "20px",
    height: "100%",
  };
  const containerTableAndHeadersStyles = {
    maxWidth: "100%",
    marginTop: "20px",
    justifyContent: "start",
    paddingTop: "10px",
    backgroundColor: "white",
  };

  const menuStatusIconStyles = {
    fontSize: "18px",
    marginRight: "9px",
  };
  const containerInformationContactPlanStyles = {
    marginTop: "10px",
    marginBottom: "20px",
  };
  const informationContactInvitedGridContainer = {
    alignItems: "start",
    justifyContent: "space-between",
    backgroundColor: "#ffffff",
    marginLeft: "0px",
    marginBottom: "20px",
    boxShadow: "1px 1px 3px #959595",
    paddingLeft: "10px",
    paddingBottom: "10px",
    lineHeight: "1.1rem",
  };
  const filterContainerStyles = {
    marginTop: "7px",
    marginLeft: "75px",
  };

  if (longmatches) {
    filterContainerStyles.marginLeft = 0;
    filterContainerStyles.marginTop = 7;
  }

  return (
    <div className="standard-wrapper">
      <Container
        spacing={4}
        lg={12}
        md={12}
        sm={12}
        xs={12}
        style={globalContainerStyles}
      >
        {/* Table and Header */}

        <Grid
          xs={12}
          lg={12}
          md={12}
          sm={12}
          es={12}
          className='header-inbox'>
          <SubtitleCustom
            title={t("signatureReceivePanelView.receiveRequest")}
            children={
              !props.canSignByVolume ?
                null
                : props.disabledVolumeSign ?
                  <TooltipHLPure
                    positionTooltip={"left"}
                    titleTooltip={t("signatureReceivePanel.byVolume.mainButton.title")}
                    descriptionTooltip={t("signatureReceivePanel.byVolume.mainButton.tooltip")}
                    customImg={`${process.env.REACT_APP_AWS_S3_BUCKET_URL}microservices/MiFirma/assets/inbox/icono_multiples_firmas.svg`}
                    styleCustomImg="volumeSignIcon"
                  />
                  :
                  <img
                    onClick={!props.disabledVolumeSign ? () => props.showVolumeDialog(true) : null}
                    src={`${process.env.REACT_APP_AWS_S3_BUCKET_URL}microservices/MiFirma/assets/inbox/icono_multiples_firmas.svg`}
                    className="volumeSignIcon"
                  />
            }
          />
        </Grid>

        <div className="table-wapprer-buttons">
          <Tooltip
            openDelay={600}
            position="top"
            anchorElement="target"
            tooltipClassName="tooltipGeneralStyle"
          >
            <button
              title={t("signatureReceivePanelView2.tooltipTabReceive")}
              className={`table-filter-buttons table-button-blue ${props.buttonFilterSelectedBlue}`}
              onClick={() => props.onSelectSignRequestList(1)}
            >
              <span style={menuStatusIconStyles}>
                <img src={ItemMenuBlueImage} alt="icon" width={14}></img>
              </span>
              <span
                className="SignatureReceivePanelView-title-filter"
                title={t("signatureReceivePanelView2.tooltipTabReceive")}
              >
                {t("signatureReceivePanelView2.tabTitleReceive")}
              </span>
            </button>
          </Tooltip>

          {!props.showSent ? null : (
            <Tooltip
              openDelay={600}
              position="top"
              anchorElement="target"
              tooltipClassName="tooltipGeneralStyle"
            >
              <button
                title={t("signatureReceivePanelView2.tooltipTabRequest")}
                className={`table-filter-buttons table-button-blue ${props.buttonFilterSelectedGreen}`}
                onClick={() => props.onSelectSignRequestList(2)}
              >
                <span style={menuStatusIconStyles}>
                  <img src={ItemMenuGreenImage} alt="icon" width={14}></img>
                </span>
                <span
                  className="SignatureReceivePanelView-title-filter"
                  title={t("signatureReceivePanelView2.tooltipTabRequest")}
                >
                  {t("signatureReceivePanelView2.tabTitleRequest")}
                </span>
              </button>
            </Tooltip>
          )}

          <div className="filter">
            <FilterHLPure options={filterOptions} optionsValue="Pendientes"
              onFilterChange={(event) => filterChange(event)} />
          </div>
        </div>
        {/* <GridHLPure
          {...props}
          dataGrid={requests}
          skip={0}
          take={6}
          onSelectedItem={setSelectedUser}
          titleRow1={"Solicitud"}
          fieldRow1={"solicitudeName"}
          extraColumnInbox
          otherExtraColumnInbox
          featuresColumnInbox
          titleRow3={'Estatus'}
          fieldRow3={"solicitudeStatus"}
          titleExtraColumn={'Fecha de alta'}
          fieldExtraColumn={"solicitudeStartDate"}
          fieldRow4={"solicitudeStartDate"}
          otherFieldExtraColumn={'solicitudeLimitDate'}
          titleOtherExtraColumn={'Fecha límite'}
          fieldRow5={"solicitudeLimitDate"}
          otherFeaturesColumn={"solicitudeAdditionalData"}
          titleFeaturesColumn={"Características"}
          columnFourForInbox
          iconFourthActive
          labelFourthActions={'Ver detalle'}
          titleRow4={"Acciones"}
          styleCol1={"signatureReceivePanel-cellItemStylesCol1"}
          styleCol3={"signatureReceivePanel-cellItemStylesCol3"}
          styleCol4={"signatureReceivePanel-cellItemStylesCol4"}
          styleCol5={"signatureReceivePanel-cellItemStylesCol5"}
          styleCol6={"signatureReceivePanel-cellItemStylesCol6"}
          styleCol7={"signatureReceivePanel-cellItemStylesCol7"}
          columnThreeInbox
          inboxTypeCell
          showFeatures={showFeatures}
          showLimitDate={showLimitDate}
          showCreatedDate={showCreatedDate}
          showStatus={showStatus}
          tooltipDetail={tooltipSeeDetail}
          tracking={tracking}
          selectedFilter={selectedValueFilter}
          view={"index"}
          seeDetail={edit}
          tooltipDelete={tooltipDelete}
          widthForFirstColumn={isMobile ? 200 : 350}
          stylesForLastColumn={"signatureReceivePanel-cellItemStyles4-mq"}
          stateSortStart={stateSortStart}
          stateSortLimit={stateSortLimit}
          changeSort={props.filterByState}
          showTracking={showIconTracking}
        /> */}
        <GridHLPure
          {...props}
          dataGrid={requests}
          skip={0}
          take={6}
          fieldSubtitle={"inboxType"}
          onSelectedItem={setSelectedUser}
          selectedFilter={selectedValueFilter}
          //Primera columna
          titleRow1={t("signatureReceivePanelView2.grid.title.1")}
          fieldRow1={"solicitudeName"}
          styleCol1={"signatureReceivePanel-col1"}
          //Segunda columna (aunque diga 3)
          columnThree={!showStatus}
          titleRow3={t("signatureReceivePanelView2.grid.title.3")}
          fieldRow3={"solicitudeStatus"}
          styleCol2={"signatureReceivePanel-col2"}
          //Tercera columna 
          extraColumnInbox={!showCreatedDate}
          titleExtraColumn={t("signatureReceivePanelView2.grid.title.create.date")}
          fieldRow4={"solicitudeStartDate"}
          styleCol3={"signatureReceivePanel-col3"}
          otherExtraColumnInbox={!showLimitDate}
          titleOtherExtraColumn={t("signatureReceivePanelView2.grid.title.limit.date")}
          fieldRow5={"solicitudeLimitDate"}
          featuresColumnInbox={!showFeatures}
          titleFeaturesColumn={t("signatureReceivePanelView2.grid.title.characteristics")}
          fieldRow6={"solicitudeAdditionalData"}
          columnFourForInbox
          titleRow4={!showActions ? t("signatureReceivePanelView2.grid.title.actions") : ""}
          labelFourthActions={t("signatureReceivePanelView2.grid.title.detail")}
          inboxTypeCell
          styleCol4={"signatureReceivePanel-colActions"}
          widthHeaderCol4={"signatureReceivePanel-colActions"}
          stateSortStart={stateSortStart}
          stateSortLimit={stateSortLimit}
          changeSort={props.filterByState}
          tooltipDetail={tooltipSeeDetail}
          tooltipTracking={tooltipTracking}
          tooltipDelete={tooltipDelete}
          seeDetail={edit}
          labelsColumnsNoPadding
          widthHeader={"signatureReceivePanel-col1Header"}
          showTracking={showIconTracking}
        />
        {/* Information of plan, contact and Ad */}
        {props.userType.id !==
          Number(Number(process.env.REACT_APP_USER_TYPE_INVITADO)) ? (
          <div>
            {props.userType.id ==
              Number(process.env.REACT_APP_USER_TYPE_ADMINISTRADOR) ? (
              <PromotionalFooterPure />
            ) : (
              <PromotionalFooterPure />
            )}
          </div>
        ) : (
          <Container
            xs={12}
            lg={12}
            md={12}
            sm={12}
            es={12}
            style={containerInformationContactPlanStyles}
          >
            <Grid container xs={12} lg={12} md={12} sm={12} es={12} spacing={2}>
              <PromotionalFooterPure />
            </Grid>
            <Grid
              container
              xs={12}
              lg={12}
              md={12}
              sm={12}
              es={12}
              spacing={2}
              style={informationContactInvitedGridContainer}
            >
              <InformationADAkubicaFirmaDigitalInvitedPure
                onInvitedRedirectRegister={props.onInvitedRedirectRegister}
              />
            </Grid>
          </Container>
        )}

        {/* Dialog Delete Request */}
        <DialogDeleteSignaturePure
          {...props}
          toggleDialogDeleteRequest={props.toggleDialogDeleteRequest}
          handleCommentsDelete={props.handleCommentsDelete}
          deleteSignRequest={props.deleteSignRequest}
        />

        {/* Alerts of Notification Completed and Loadign */}
        <DialogSystemGLPure
          toggleLoadingRequesting={props.toggleLoadingRequesting}
          showLoadingRequesting={props.showLoadingRequesting}
          toggleCompletedRequesting={props.toggleCompletedRequesting}
          toggleErrorRequesting={props.toggleErrorRequesting}
          showCompletedRequesting={props.showCompletedRequesting}
          showErrorRequesting={props.showErrorRequesting}
          messageComplete={props.messageComplete}
          message={props.message}
        />

        {props.showVolumeSign &&
          <DialogFormHLPure
            titleDialog={t("signatureReceivePanel.byVolume.mainButton.title")}
            className={"dialogStyles"}
            dialogCollaboratorWidth={"50%"}
            dialogCollaboratorHeight={"50%"}
            cancel={() => {
              props.showVolumeDialog(false)
            }}
          >
            {!props.verifiedNip ?
              <>
                <Grid
                  item
                  xs={12}
                  lg={12}
                  md={12}
                  sm={12}
                  es={12}
                  className="signatureReceivePanel-container-volumeSign"
                >
                  <GridSimpleReadHLPure
                    customClassGrid="signatureReceivePanel-customGrid"
                    dataGrid={props.volumeSigns}
                    skip={0}
                    take={props.volumeSigns.length}
                    pageableGrid={false}
                    titleRow1={"Solicitud"}
                    fieldRow1={"name"}
                    fieldSubtitle={"limitDate"}
                    textSubtitle={"subText"}
                    column2Status={window.innerWidth > 900}
                    fieldRow2={"numDocuments"}
                    titleRow2={"Cantidad documentos"}
                    styleCol2={"signatureReceivePanel-col-2"}
                    styleHeader2={"signatureReceivePanel-header-2"}
                    columnThree={window.innerWidth > 650}
                    fieldRow3={"numSigns"}
                    titleRow3={"Cantidad firmas"}
                    styleCol3={"signatureReceivePanel-col-3"}
                    styleHeader3={"signatureReceivePanel-header-3"}
                    onSelectedItem={setSelectedItem}
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  lg={12}
                  md={12}
                  sm={12}
                  es={12}
                  className="signatureReceivePanel-totalSigns-container-volumeSign"
                >
                  Total de solicitudes a firmar: {props.volumeSigns.length > +process.env.REACT_APP_QUANTITY_SIGNATURES
                    ? +process.env.REACT_APP_QUANTITY_SIGNATURES
                    : props.volumeSigns.length}
                </Grid>
                <Grid
                  item
                  xs={12}
                  lg={12}
                  md={12}
                  sm={12}
                  es={12}
                  className="signatureReceivePanel-inputs-container-volumeSign"
                >
                  <ValidationCodePure
                    data={props.nip}
                    setData={props.setNip}
                    validationLength={4}
                    title={'NIP de firma base'}
                    hide
                    autoFocusNIP
                  />
                  <Grid
                    item
                    xs={12}
                    lg={12}
                    md={12}
                    sm={12}
                    es={12}
                    className="signatureReceivePanel-buttons-container-volumeSign"
                  >
                    <ButtonHLPure
                      onClickBtn={() => props.showVolumeDialog(false)}
                      nameBtn={"Cancelar"}
                    />
                    <ButtonHLPure
                      disabled={props.nip.length !== 4}
                      onClickBtn={props.setVerifiedNip}
                      nameBtn={"Continuar"}
                      primary
                    />
                  </Grid>
                </Grid>
              </>
              : <div className="signatureReceivePanel-body-container">
                <Grid
                  item
                  xs={12}
                  lg={12}
                  md={12}
                  sm={12}
                  es={12}
                  className="canvas-draw-container"
                >
                  <CanvasDraw
                    ref={pad}
                    className="canvas-draw-container"
                    loadTimeOffset={0}
                    lazyRadius={2}
                    brushRadius={2}
                    brushColor={"#000"}
                    catenaryColor={"#0a0302"}
                    gridColor={"rgba(150,150,150,0.17)"}
                    hideGrid
                    canvasWidth={"100%"}
                    canvasHeight={(isMobile) ? window.innerWidth / 2.09 : 300}
                    disabled
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  lg={12}
                  md={12}
                  sm={12}
                  es={12}
                  className="signatureReceivePanel-buttons-container-volumeSign-verifiedNip"
                >
                  <ButtonHLPure
                    nameBtn="Regresar"
                    onClickBtn={() => props.returnVerifyNip()}
                  />
                  <ButtonHLPure
                    nameBtn="Firmar"
                    onClickBtn={() => props.signByVolume(isMobile)}
                    primary
                  />
                </Grid>
              </div>
            }
          </DialogFormHLPure>
        }
      </Container>
    </div>
  );
}

export { SignatureReceivePanelView as default };